import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { px2rem } from '../utils/helpers/style.js';
import { timings } from '../constants/timings.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var sizingsNative = {
  s: {
    height: 48,
    fontSize: 16,
    label: {
      activeFontSize: 12,
      activeTop: 6,
      inactiveTop: 15,
      iconMargin: -4,
      multiline: {
        activeTop: 14,
        inactiveTop: 14
      }
    },
    textInput: {
      paddingTop: 13,
      paddingHorizontal: 16,
      iconSize: 24,
      iconMargin: 8
    }
  },
  m: {
    height: 56,
    fontSize: 16,
    label: {
      activeFontSize: 14,
      /**
       * Adjusts the position of the label vertically
       */
      activeTop: 8,
      inactiveTop: 19,
      iconMargin: -4,
      multiline: {
        activeTop: 14,
        inactiveTop: 14
      }
    },
    textInput: {
      paddingTop: 17,
      paddingHorizontal: 16,
      iconSize: 24,
      iconMargin: 8
    }
  },
  l: {
    height: 64,
    fontSize: 18,
    label: {
      activeFontSize: 14,
      /**
       * Adjusts the position of the label vertically
       */
      activeTop: 10,
      inactiveTop: 22,
      iconMargin: 4,
      multiline: {
        activeTop: 14,
        inactiveTop: 14
      }
    },
    textInput: {
      paddingTop: 20,
      paddingHorizontal: 16,
      iconSize: 24,
      iconMargin: 16
    }
  }
};
var inputFieldAttributesNative = {
  /**
   * Affects label and border active colors
   */
  color: 'primary',
  /**
   * Affects input value text color
   */
  font: {
    color: 'text'
  },
  /**
   * Same as borderStyle prop. Used to define which borders are used. To style borderRadius use theme.borders.radius.
   */
  borderStyle: 'full',
  /**
   * Passed directly right side Icon as props
   */
  inputIconStyle: {
    alignItems: 'center',
    color: 'text.disabled',
    /**
     * Passed as color prop is disabled
     */
    disabled: 'label.disabled'
  },
  /**
   * Passed directly as style prop to right side iconButton (wraps the icon)
   */
  iconButtonStyle: {
    marginHorizontal: 8,
    borderColor: 'transparent',
    backgroundColor: 'transparent'
  },
  input: {
    top: 4
  },
  errorColor: 'alert',
  backgroundColor: 'input.background',
  placeholderColor: 'input.placeholder',
  disabled: {
    border: {
      color: 'border.inactive'
    },
    label: {
      color: 'label.disabled'
    },
    backgroundColor: 'input.disabled'
  },
  readOnly: {
    border: {
      color: 'transparent'
    },
    label: {
      color: 'label.filled'
    }
  },
  inactive: {
    border: {
      color: 'border.inactive'
    },
    label: {
      color: 'label.unfilled'
    },
    /**
     * Affects label when input field is not active
     */
    hasValueColor: 'label.filled'
  },
  label: {
    marginLeft: 18,
    marginLeftWithBorder: 18,
    withLeftIcon: {
      marginLeft: -1,
      marginLeftWithBorder: -1
    },
    withRightIcon: {
      marginRight: 46,
      marginRightWithBorder: 48
    }
  },
  transparent: {
    inactive: {
      backgroundColor: 'transparent',
      border: {
        color: 'border.desaturated',
        opacity: 0.4
      },
      label: {
        color: 'label.desaturated',
        opacity: 1
      },
      text: {
        color: 'label.desaturated',
        opacity: 1
      },
      icon: {
        color: 'text.desaturated',
        opacity: 0.4
      }
    },
    inactiveWithValue: {
      backgroundColor: 'transparent',
      border: {
        color: 'border.desaturated',
        opacity: 0.4
      },
      label: {
        color: 'label.desaturated',
        opacity: 1
      },
      text: {
        color: 'label.desaturated',
        opacity: 1
      },
      icon: {
        color: 'text.desaturated',
        opacity: 0.4
      }
    },
    active: {
      backgroundColor: 'input.background',
      border: {
        color: 'transparent',
        opacity: 0
      },
      label: {
        color: 'primary',
        opacity: 1
      },
      text: {
        color: 'text',
        opacity: 1
      },
      icon: {
        color: 'primary',
        opacity: 1
      }
    },
    disabled: {
      backgroundColor: 'transparent',
      border: {
        color: 'border.desaturated',
        opacity: 0.4
      },
      label: {
        color: 'label.desaturated',
        opacity: 0.4
      },
      text: {
        color: 'label.desaturated',
        opacity: 0.4
      },
      icon: {
        color: 'text.desaturated',
        opacity: 0.4
      }
    },
    readOnly: {
      backgroundColor: 'transparent',
      border: {
        color: 'transparent',
        opacity: 0
      },
      label: {
        color: 'label.desaturated',
        opacity: 1
      },
      text: {
        color: 'label.desaturated',
        opacity: 0.4
      },
      icon: {
        color: 'text.desaturated',
        opacity: 0.4
      }
    },
    error: {
      backgroundColor: 'input.background',
      border: {
        color: 'transparent',
        opacity: 0
      },
      label: {
        color: 'alert',
        opacity: 1
      },
      text: {
        color: 'alert',
        opacity: 1
      },
      icon: {
        color: 'alert',
        opacity: 1
      }
    },
    errorMessage: {
      color: 'label.desaturated'
    },
    colorTransitionOpacity: 0.7,
    colorTransitionDuration: timings.base
  },
  sizings: sizingsNative
};
var inputFieldThemeNative = _objectSpread(_objectSpread({}, inputFieldAttributesNative), {}, {
  variants: {
    condensed: {
      borderStyle: 'bottomOnly',
      label: {
        marginLeft: 16,
        marginLeftWithBorder: 18,
        withLeftIcon: {
          marginLeft: -8,
          marginLeftWithBorder: -8
        }
      },
      input: {
        top: 0
      }
    }
  }
});
var sizingsWeb = {
  s: {
    height: px2rem(48),
    fontSize: px2rem(16),
    icons: {
      size: 24,
      paddingHorizontal: 16
    },
    label: {
      activeFontSize: px2rem(12),
      fontSize: px2rem(16),
      lineHeight: px2rem(48)
    },
    paddings: {
      input: {
        top: px2rem(18),
        bottom: px2rem(5),
        horizontalDefault: 16,
        horizontalWithIcon: 48
      },
      label: {
        top: px2rem(0),
        activeTop: px2rem(0),
        bottom: px2rem(0)
      }
    }
  },
  m: {
    height: px2rem(56),
    fontSize: px2rem(18),
    icons: {
      size: 24,
      paddingHorizontal: 16
    },
    label: {
      activeFontSize: px2rem(14),
      fontSize: px2rem(18),
      lineHeight: px2rem(56)
    },
    paddings: {
      input: {
        top: px2rem(23),
        bottom: px2rem(5),
        horizontalDefault: 16,
        horizontalWithIcon: 48
      },
      label: {
        top: px2rem(0),
        activeTop: px2rem(2),
        bottom: px2rem(0)
      }
    }
  },
  l: {
    height: px2rem(64),
    fontSize: px2rem(18),
    icons: {
      size: 24,
      paddingHorizontal: 16
    },
    label: {
      activeFontSize: px2rem(14),
      fontSize: px2rem(18),
      lineHeight: px2rem(64)
    },
    paddings: {
      input: {
        /**
         * Affects input position when text is entered or field is active
         */
        top: px2rem(28),
        /**
         * Affects input position when text is entered or field is active
         */
        bottom: px2rem(11),
        horizontalDefault: 16,
        horizontalWithIcon: 64
      },
      label: {
        top: px2rem(0),
        activeTop: px2rem(0),
        bottom: px2rem(0)
      }
    }
  }
};
var inputFieldAttributesWeb = {
  color: 'primary',
  background: 'background',
  error: 'alert',
  textColor: 'text',
  borderStyle: 'full',
  inactive: 'text.disabled',
  placeholder: 'input.placeholder',
  dismissIcon: 'text',
  label: {
    color: 'label.filled',
    fontWeight: 400
  },
  disabled: {
    background: 'input.disabled',
    label: 'label.disabled',
    border: 'border.disabled',
    color: 'text.disabled'
  },
  transparent: {
    background: 'transparent',
    label: 'label.desaturated',
    border: 'border.desaturated',
    text: 'text.desaturated',
    inactiveOpacity: 0.4,
    activeOpacity: 1.0
  },
  sizings: sizingsWeb
};
var inputFieldThemeWeb = _objectSpread(_objectSpread({}, inputFieldAttributesWeb), {}, {
  variants: {
    condensed: {
      borderStyle: 'bottomOnly'
    }
  }
});

export { inputFieldThemeNative, inputFieldThemeWeb, sizingsNative };
